import React from "react";

const machinery = [
  {
    name: "Double profile corrugation machine",
    image: "/assets/doublem.png",
  },
  {
    name: "42 inch narrow flute corrugation machine",
    image: "/assets/42inch.png",
  },
  {
    name: "E-flute corrugation machine",
    image: "/assets/eflu.png",
  },
  {
    name: "Auto cutters",
    image: "/assets/autocut.png",
  },
  {
    name: "Rotary cutting and creasing machines",
    image: "/assets/four.png",
  },
  {
    name: "Flexo printing machines",
    image: "/assets/flexo.png",
  },
  {
    name: "Eccentric slotter machines",
    image: "/assets/ecc.png",
  },
  {
    name: "Box stitching and die cutting machines",
    image: "/assets/diecut.png",
  },
];

const process = [
  "Corrugation",
  "Auto Cutting",
  "Lamination & Printing",
  "Pasting",
  "Creasing & Slotting",
  "Stitching / Finishing",
  "Final Inspection",
  "Bundling & Dispatch"
];

const qualityTools = [
  "GSM Tester",
  "Bursting Strength Tester",
  "Glow Viscosity Tester",
  "Vernier Caliper",
  "Measuring Tape",
  "Steel Rule",
  "Weighing Scale"
];

function Infrastructure() {
  return (
    <div className="page-shell">
      <section className="page-hero page-hero-light">
        <div className="container">
          <p className="eyebrow">Infrastructure</p>
          <h1>Facilities that support consistent quality and dependable output</h1>
          <p>
            Our production setup is built for process control, timely execution, and reliable packaging performance at
            scale.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container split-layout">
          <div>
            <p className="eyebrow">Machinery</p>
            <h2>Production equipment built for precision</h2>
            <div className="list-card">
              <div className="cards-4">
  {machinery.map((machine, index) => (
    <div key={index} className="content-card">
      
      <h3>{machine.name}</h3>

      <img
        src={machine.image}
        alt={machine.name}
        className="machine-image"
      />

    </div>
  ))}
</div>
            </div>
          </div>
          <div>
            <p className="eyebrow">Capabilities</p>
            <h2>Manufacturing strengths that improve delivery confidence</h2>
            <div className="capability-grid">
              <div className="info-card compact-card">
                <h3>Custom Sizes</h3>
                <p>Packaging tailored to product dimensions, load capacity, and handling needs.</p>
              </div>
              <div className="info-card compact-card">
                <h3>Printing Support</h3>
                <p>Branded and identification-ready packaging with neat finishing and usability.</p>
              </div>
              <div className="info-card compact-card">
                <h3>Fast Dispatch</h3>
                <p>Production planning aligned with delivery deadlines and customer schedules.</p>
              </div>
              <div className="info-card compact-card">
                <h3>Quality Inspection</h3>
                <p>Checks integrated across stages to maintain durability and dimensional accuracy.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-muted">
        <div className="container">
          <div className="section-heading center">
            <p className="eyebrow">Process Flow</p>
            <h2>A clear manufacturing flow from raw material to dispatch</h2>
          </div>
          <div className="process-grid">
            {process.map((step, index) => (
              <div className="process-step" key={step}>
                <strong>{String(index + 1).padStart(2, "0")}</strong>
                <p>{step}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-heading">
            <p className="eyebrow">Quality Testing</p>
            <h2>Instruments that support quality verification</h2>
          </div>
          <div className="grid cards-4">
            {qualityTools.map((tool) => (
              <div className="quality-card" key={tool}>
                {tool}
              </div>
            ))}
          </div>
        </div>
      </section>
     
    </div>
  );
}

export default Infrastructure;
